import type { Trade, TradeOption } from "@simplybusiness/mobius-trade-selector";

export const EMPTY_TRADE_OPTION: TradeOption = Object.freeze({
  label: "",
  value: "",
  definition: "",
  vertical: "",
});

export const getTradeOptionFromAnswer = (
  trade: string,
  definition?: string,
): TradeOption => ({
  ...EMPTY_TRADE_OPTION,
  label: trade,
  value: trade,
  definition: definition ?? "",
});

export const convertTradesToOptions = (trades: Trade[]): TradeOption[] => {
  return trades.map(({ value, vertical, definition }) => ({
    label: value,
    value,
    vertical,
    definition,
  }));
};
